export enum ETestFumee {
    TestNonRealise = 1,
    ConfinementSalle,
    AbsenceConfinementSalle
}